/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SocialExportCreateRudoFolderMutationRequest, SocialExportCreateRudoFolderMutationResponse, SocialExportCreateRudoFolderPathParams, SocialExportCreateRudoFolder400, SocialExportCreateRudoFolder401, SocialExportCreateRudoFolder403, SocialExportCreateRudoFolder404 } from "../models/SocialExportCreateRudoFolder";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { socialExportCreateRudoFolder } from "../axios/socialExportCreateRudoFolder";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const socialExportCreateRudoFolderMutationKey = () => [{ url: '/social-export/v1/platforms/rudo/:connectionId/folders' }] as const

export type SocialExportCreateRudoFolderMutationKey = ReturnType<typeof socialExportCreateRudoFolderMutationKey>

export function socialExportCreateRudoFolderMutationOptions<TContext = unknown>(config: Partial<RequestConfig<SocialExportCreateRudoFolderMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = socialExportCreateRudoFolderMutationKey()
        return mutationOptions<SocialExportCreateRudoFolderMutationResponse, ResponseErrorConfig<SocialExportCreateRudoFolder400 | SocialExportCreateRudoFolder401 | SocialExportCreateRudoFolder403 | SocialExportCreateRudoFolder404>, {connectionId: SocialExportCreateRudoFolderPathParams["connectionId"], data: SocialExportCreateRudoFolderMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ connectionId, data }) => {
            return socialExportCreateRudoFolder(connectionId, data, config)
          },
        })

}

/**
 * @description Creates a folder on the connected Rudo account. Use the returned id as folderId when publishing or as the connection default.
 * @summary Create a Rudo folder for a connection
 * {@link /social-export/v1/platforms/rudo/:connectionId/folders}
 */
export function useSocialExportCreateRudoFolder<TContext>(options: 
{
  mutation?: UseMutationOptions<SocialExportCreateRudoFolderMutationResponse, ResponseErrorConfig<SocialExportCreateRudoFolder400 | SocialExportCreateRudoFolder401 | SocialExportCreateRudoFolder403 | SocialExportCreateRudoFolder404>, {connectionId: SocialExportCreateRudoFolderPathParams["connectionId"], data: SocialExportCreateRudoFolderMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<SocialExportCreateRudoFolderMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? socialExportCreateRudoFolderMutationKey()

          const baseOptions = socialExportCreateRudoFolderMutationOptions(config) as UseMutationOptions<SocialExportCreateRudoFolderMutationResponse, ResponseErrorConfig<SocialExportCreateRudoFolder400 | SocialExportCreateRudoFolder401 | SocialExportCreateRudoFolder403 | SocialExportCreateRudoFolder404>, {connectionId: SocialExportCreateRudoFolderPathParams["connectionId"], data: SocialExportCreateRudoFolderMutationRequest}, TContext>
          

          return useMutation<SocialExportCreateRudoFolderMutationResponse, ResponseErrorConfig<SocialExportCreateRudoFolder400 | SocialExportCreateRudoFolder401 | SocialExportCreateRudoFolder403 | SocialExportCreateRudoFolder404>, {connectionId: SocialExportCreateRudoFolderPathParams["connectionId"], data: SocialExportCreateRudoFolderMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<SocialExportCreateRudoFolderMutationResponse, ResponseErrorConfig<SocialExportCreateRudoFolder400 | SocialExportCreateRudoFolder401 | SocialExportCreateRudoFolder403 | SocialExportCreateRudoFolder404>, {connectionId: SocialExportCreateRudoFolderPathParams["connectionId"], data: SocialExportCreateRudoFolderMutationRequest}, TContext>
      
}